// extracted by mini-css-extract-plugin
module.exports = {"heading":"HeadingTwo--heading--32O25"};